var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFalseicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0.375C18.4219 0.375 23.625 5.57812 23.625 12C23.625 18.4219 18.4219 23.625 12 23.625C5.57812 23.625 0.375 18.4219 0.375 12C0.375 5.57812 5.57812 0.375 12 0.375ZM17.6719 15.0938L14.625 12L17.6719 8.95312C17.9062 8.76562 17.9062 8.39062 17.6719 8.15625L15.8438 6.32812C15.6094 6.09375 15.2344 6.09375 15.0469 6.32812L12 9.375L8.95312 6.32812C8.71875 6.09375 8.34375 6.09375 8.15625 6.32812L6.28125 8.15625C6.04688 8.39062 6.04688 8.76562 6.28125 8.95312L9.375 12L6.28125 15.0469C6.04688 15.2812 6.04688 15.6562 6.28125 15.8438L8.10938 17.7188C8.34375 17.9531 8.71875 17.9531 8.90625 17.7188L12 14.625L15.0469 17.7188C15.2344 17.9531 15.6094 17.9531 15.8438 17.7188L17.6719 15.8906C17.9062 15.6562 17.9062 15.2812 17.6719 15.0938Z",
    fill: "#BE5C5C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFalseicon);
export default __webpack_public_path__ + "static/media/falseicon.4a31ad853b53dd22467e3e14b5b76f14.svg";
export { ForwardRef as ReactComponent };